import RespuestaService from 'src/modules/respuesta/respuestaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'RESPUESTA_VIEW';

const respuestaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: respuestaViewActions.FIND_STARTED,
      });

      const record = await RespuestaService.find(id);

      dispatch({
        type: respuestaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: respuestaViewActions.FIND_ERROR,
      });

      getHistory().push('/respuesta');
    }
  },
};

export default respuestaViewActions;
